import type { ReactNode } from 'react';

/**
 * Helpers de persistance pour OnboardingModal (MVP2.5 T7).
 *
 * Extraits dans un fichier séparé pour respecter la règle ESLint
 * `react-refresh/only-export-components` (un fichier de composant React ne
 * doit pas exporter de fonctions/constantes utilisées par d'autres composants).
 */

const STORAGE_KEY_PREFIX = 'tcc_onboarded_';

/**
 * Vérifie si le module a déjà été vu. SSR-safe via try/catch (utile pour le
 * setup Vitest jsdom où localStorage existe mais le harness peut throw).
 */
export function hasOnboarded(moduleSlug: string): boolean {
  try {
    if (typeof window === 'undefined') return true;
    return window.localStorage.getItem(STORAGE_KEY_PREFIX + moduleSlug) === '1';
  } catch {
    return true;
  }
}

/**
 * Marque le module comme vu. No-op silencieux si localStorage indisponible
 * (mode privé Safari iOS, quotaExceeded, etc.).
 */
export function markOnboarded(moduleSlug: string): void {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY_PREFIX + moduleSlug, '1');
  } catch {
    // Mode privé Safari → localStorage throws. On préfère laisser l'onboarding
    // se réafficher silencieusement plutôt que crasher le module.
  }
}

export interface OnboardingSlide {
  title: string;
  body: ReactNode;
  /**
   * Petit visuel optionnel — ASCII art typographique pour illustrer
   * l'idée. Pas d'emoji caractère ; le contenu peut être un fragment React
   * avec des spans monospace pour les annotations type "(a1...h8)".
   */
  visual?: ReactNode;
}
